// Modern ES6+ imports
console.log("📁 Script file loaded");

import { Splide } from "@splidejs/splide";
import GLightbox from 'glightbox';


// Your main app
class TongkolspaceApp {
    constructor() {
        console.log("🚀 Tongkolspace App Initialized wakkakk");

        this.init();
        this.initSliders();
    }

    init() {
        console.log("🚀 Tongkolspace App Initialized wakkakk");
        this.search();
        this.initTabs();
        this.initVideoPopup();
        this.initGrid();
        this.initDropdown();
        this.initLightBox();
    }
    
    initLightBox(){
        // const lightbox = GLightbox({
        //     touchNavigation: true,
        //     loop: true,
        //     autoplayVideos: true
        // });

        /*
        IMAGE / VIDEO LIGHTBOX
        */
        GLightbox({
            touchNavigation: true,
            loop: true,
            autoplayVideos: true
        });

        /*
        MODAL LIGHTBOX
        */
        const modalLightbox = GLightbox({
            selector: '.js-modal'
        });

        document.querySelectorAll('.js-modal').forEach((button) => {

            button.addEventListener('click', (e) => {

                e.preventDefault();

                const target = button.dataset.modal;
                const modal = document.querySelector(target);

                if (!modal) return;

                modalLightbox.setElements([
                    {
                        content: modal.innerHTML,
                        className: 'is-custom-modal'
                    }
                ]);

                modalLightbox.open();

            });

        });
    }
    initSliders() {
        console.log("Slider App Initialized wakkakk-=========");

        const isRtl = document.documentElement.getAttribute("dir") === "rtl";
        const splideBaseOptions = isRtl ? { direction: "rtl" } : {};

        // Splide sliders
        const heroSlider = document.querySelectorAll(".hero-slider__splide");
        heroSlider.forEach((element) => {
            new Splide(element, {
                ...splideBaseOptions,
                perPage: 1,
            }).mount();
        });

        const testimonySlider = document.querySelectorAll(".testimony-slider__splide");
        testimonySlider.forEach((element) => {
            new Splide(element, {
                ...splideBaseOptions,
                autoWidth: true,
                perPage: 2,
                breakpoints: {
                    991.98: {
                        perPage: 1,
                    },
                },

            }).mount();
        });

        const mobileSlider = document.querySelectorAll(".mobileSlider");
        mobileSlider.forEach((element) => {
            new Splide(element, {
                ...splideBaseOptions,
                autoWidth: true,
            }).mount();
        });

        const cardHistorySlider = document.querySelectorAll(".cardHistory__splide");
        // cardHistorySlider.forEach((element) => {
        //     new Splide(element, {
        //         perPage: 1,
        //     }).mount();
        // });

        cardHistorySlider.forEach((element) => {
            const splide = new Splide(element, {
                ...splideBaseOptions,
                perPage: 1,
                arrows: true,
            });

            splide.on("mounted", function () {
                const slideCount = splide.length; // jumlah slide

                if (slideCount <= 1) {
                    const arrows = element.querySelector(".splide__arrows");
                    if (arrows) arrows.style.display = "none";
                }
            });

            splide.mount();
        });

        const surveiSlider = document.querySelectorAll(".survei__splide");
        surveiSlider.forEach((element) => {
            new Splide(element, {
                ...splideBaseOptions,
                perPage: 1,
            }).mount();
        });



        // const fasilitySlider = document.querySelectorAll(".facilities-slider__splide");
        // fasilitySlider.forEach((element) => {
        //     new Splide(element, {
        //         ...splideBaseOptions,
        //         loop: true,
        //         perPage: 3,
        //         gap: '20px',
        //         breakpoints: {
        //             991.98: {
        //                 perPage: 1,
        //             },
        //         },
        //     }).mount();
        // });

        const fasilitySlider = document.querySelectorAll(".facilities-slider__splide");

        fasilitySlider.forEach((element) => {
            const slides = element.querySelectorAll('.splide__slide');
            const totalSlides = slides.length;

            const perPage = 3;
            const shouldDisableNav = totalSlides <= perPage;

            new Splide(element, {
                ...splideBaseOptions,
                perPage: perPage,

                arrows: !shouldDisableNav,
                pagination: !shouldDisableNav,
                drag: !shouldDisableNav,

                breakpoints: {
                    991.98: {
                        perPage: 1,

                        // mobile selalu aktif
                        arrows: totalSlides > 1,
                        pagination: totalSlides > 1,
                        drag: totalSlides > 1,
                    },
                },
            }).mount();
        });

    }

    initTabs() {
        try {
            const tabContainers = document.querySelectorAll("[data-tabs]");

            if (tabContainers.length === 0) {
                console.log("No tab containers found");
                return;
            }

            tabContainers.forEach((container, index) => {
                this.setupCustomTabs(container, index);
            });

            console.log(
                `✅ Custom tabs initialized for ${tabContainers.length} containers`
            );
        } catch (error) {
            console.error("❌ Error initializing custom tabs:", error);
        }
    }

    setupCustomTabs(container, containerIndex) {
        const triggers = container.querySelectorAll("[data-tabby]");
        const panels = [];

        // Collect all panels
        triggers.forEach((trigger) => {
            const targetId = trigger.getAttribute("data-tabby");
            const panel = document.querySelector(targetId);
            if (panel) {
                panels.push({ trigger, panel, targetId });
            }
        });

        if (panels.length === 0) {
            console.log(
                `No valid tab panels found for container #${containerIndex + 1}`
            );
            return;
        }

        // Setup click handlers
        panels.forEach(({ trigger, panel }, index) => {
            trigger.addEventListener("click", (e) => {
                e.preventDefault();
                this.activateTab(panels, index);
            });

            // Add ARIA attributes for accessibility
            trigger.setAttribute("role", "tab");
            trigger.setAttribute("aria-selected", "false");
            panel.setAttribute("role", "tabpanel");
            panel.setAttribute("aria-hidden", "true");
        });

        // Activate first tab
        this.activateTab(panels, 0);
    }

    activateTab(panels, activeIndex) {
        panels.forEach(({ trigger, panel }, index) => {
            const isActive = index === activeIndex;

            // Update trigger state
            trigger.classList.toggle("active", isActive);
            trigger.setAttribute("aria-selected", isActive.toString());

            // Update panel state
            panel.style.display = isActive ? "block" : "none";
            panel.classList.toggle("active", isActive);
            panel.setAttribute("aria-hidden", (!isActive).toString());
        });
    }

    search() {
        const triggers = document.querySelectorAll(
            ".search-trigger, .action-mobile__search"
        );
        
        const closeTrigger = document.querySelector(".cardSearch__close");
        const cardSearch = document.querySelector(".cardSearch");

        if (!triggers.length || !cardSearch) return;

        // OPEN / TOGGLE
        triggers.forEach(trigger => {
            trigger.addEventListener("click", function (e) {
                e.stopPropagation();

                console.log("akjsdlkjalskdjlakdsjlk lasjdo21u371293719283baduaweukjqwehiu");
                

                const isActive = cardSearch.classList.contains("active");

                triggers.forEach(t => t.classList.toggle("active", !isActive));
                cardSearch.classList.toggle("active", !isActive);
            });
        });

        // CLOSE BUTTON
        if (closeTrigger) {
            closeTrigger.addEventListener("click", function () {
                triggers.forEach(t => t.classList.remove("active"));
                cardSearch.classList.remove("active");
            });
        }

        // CLICK OUTSIDE CLOSE
        document.addEventListener("click", function () {
            triggers.forEach(t => t.classList.remove("active"));
            cardSearch.classList.remove("active");
        });

        // STOP PROPAGATION INSIDE SEARCH CARD
        cardSearch.addEventListener("click", function(e){
            e.stopPropagation();
        });
    }


    // YouTube Video Popup functionality

    // YouTube Video Popup functionality
    initVideoPopup() {
        document.querySelectorAll(".nug-video-popup").forEach((video) => {
            video.addEventListener("click", (event) => {
                event.preventDefault();
                this.openVideoPopup(video);
                return false;
            });
        });
    }

    getYoutubeId(url) {
        const regExp =
            /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        const match = url.match(regExp);

        if (match && match[2].length == 11) {
            return match[2];
        } else {
            return "error";
        }
    }

    openVideoPopup(videoElement) {
        // Create HTML elements
        const divPopupWrap = document.createElement("div");
        const divPopupOverlay = document.createElement("div");
        const divPopupContent = document.createElement("div");
        const divPopupClose = document.createElement("div");
        const divPopupInner = document.createElement("div");

        divPopupWrap.className = "nug-video-popup-wrap";
        divPopupOverlay.className = "nug-popup-overlay";
        divPopupContent.className = "nug-video-popup-content";
        divPopupClose.className = "nug-popup-close";
        divPopupInner.className = "nug-popup-inner";

        document.querySelector("body").prepend(divPopupWrap);
        divPopupWrap.appendChild(divPopupOverlay);
        divPopupWrap.appendChild(divPopupContent);
        divPopupContent.appendChild(divPopupClose);
        divPopupContent.appendChild(divPopupInner);

        const youtubeURL = videoElement.closest("a").getAttribute("href");
        const youtubeID = this.getYoutubeId(youtubeURL);
        const youtubeIframe = `<iframe 
        width="100%" 
        height="500" 
        src="https://www.youtube-nocookie.com/embed/${youtubeID}?autoplay=1&rel=0" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen>
      </iframe>`;
        divPopupInner.innerHTML = "";

        const div = document.createElement("div");
        div.innerHTML = youtubeIframe;
        divPopupInner.appendChild(div);

        document.body.classList.add("nug-video-popup-opened");

        // Event listeners for closing popup
        const closePopup = () => {
            document.body.classList.remove("nug-video-popup-opened");
            this.removeVideo(divPopupWrap);
        };

        divPopupOverlay.addEventListener("click", closePopup);
        divPopupClose.addEventListener("click", closePopup);

        // Add ESC key support for closing popup
        const handleEscKey = (e) => {
            if (e.key === "Escape") {
                closePopup();
                document.removeEventListener("keydown", handleEscKey);
            }
        };
        document.addEventListener("keydown", handleEscKey);
    }

    removeVideo(element) {
        if (element && element.parentNode) {
            element.parentNode.removeChild(element);
        }
    }

    initGrid(){
        const cols = 4;

        document.querySelectorAll('.grid__layout').forEach(grid => {
            const items = [...grid.children];
            const total = items.length;
            const remainder = total % cols;

            /* reset */
            items.forEach(el=>{
                el.style.gridColumn = '';
                el.classList.remove('grid-col-1','grid-col-2','grid-col-3','grid-col-4');
            });

            /* === CENTER LAST ROW LOGIC === */
            if(remainder === 1){
                items[total-1].style.gridColumn = '2 / span 2';
            }

            if(remainder === 2){
                items[total-2].style.gridColumn = '2';
                items[total-1].style.gridColumn = '3';
            }

            /* remainder === 3 → BIARKAN NORMAL */

            /* === AUTO COLOR BASED ON GRID POSITION === */
            items.forEach((item, i)=>{
            let col = (i % cols) + 1;

            // override if manually positioned
            if(item.style.gridColumn){
                col = parseInt(item.style.gridColumn);
            }

            item.classList.add(`grid-col-${col}`);
            });
        });
    }
    
    initDropdown() {
        const nav = document.querySelector(".headerBasic");
        if (!nav) return;

        /* =========================
        DROPDOWN MENU
        ========================= */
        const dropdownItems = document.querySelectorAll(".dropdown");

        dropdownItems.forEach(item => {
            
            const link = item.querySelector(":scope > a");

            // create html in a with class name .actionTrigger

            // buat elemen trigger
            const triggerLink = document.createElement("span");
            triggerLink.className = "actionTrigger";

            // masukkan ke dalam <a>
            link.appendChild(triggerLink);


            // const submenu = item.querySelector(":scope > ul.dropdown-menu");
            const submenu = item.querySelector(".dropdown-menu");

            if (!link || !submenu) return;

            triggerLink.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = submenu.classList.contains("active");

                // Tutup sibling dropdown di level yang sama
                const siblings = item.parentElement.querySelectorAll(
                    ":scope > .dropdown > .dropdown-menu.active"
                );

                siblings.forEach(menu => {
                    if (menu !== submenu) {
                        menu.classList.remove("active");

                        const parentLink = menu.closest("li.dropdown")?.querySelector(":scope > a");
                        if (parentLink) parentLink.setAttribute("aria-expanded", "false");
                    }
                });

                // Toggle current
                submenu.classList.toggle("active", !isOpen);

                // aria support
                link.setAttribute("aria-expanded", String(!isOpen));
            });
        });

        document.addEventListener("click", function () {
            // tutup semua dropdown aktif
            document.querySelectorAll(".dropdown-menu.active").forEach(menu => {
                menu.classList.remove("active");

                const parentLink = menu.closest("li.dropdown")
                    ?.querySelector(":scope > a");
                if (parentLink) parentLink.setAttribute("aria-expanded", "false");
            });
        });

        // klik di luar nav = tutup semua
        document.addEventListener("click", function (e) {
            if (!e.target.closest(".primary-navigation")) {
                nav.querySelectorAll("ul.dropdown-menu.active").forEach(menu => {
                    menu.classList.remove("active");
                });

                nav.querySelectorAll("a[aria-expanded='true']").forEach(a => {
                    a.setAttribute("aria-expanded", "false");
                });
            }
        });

        /* =========================
        MOBILE MODE
        ========================= */
        const mediaQuery = window.matchMedia("(max-width: 1199.98px)");

        const mobileHandler = () => {
            console.log("resize check:", mediaQuery.matches);
            
            if (!mediaQuery.matches) return;

            const mobileMenu = document.querySelectorAll(".action-mobile__menu");
            const navigation = document.querySelector(".primary-navigation");

            if (navigation) {
                mobileMenu.forEach(item => {
                    // hindari double event listener
                    if (item.dataset.mobileBound) return;
                    item.dataset.mobileBound = "true";

                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        const isOpen = navigation.classList.contains("active");

                        navigation.classList.toggle("active", !isOpen);
                        item.setAttribute("aria-expanded", String(!isOpen));
                    });
                });
            }

            const headerTop = document.querySelector(".headerBasic__secondary");
            const headerMenus = document.querySelector(".headerBasic__menu .primary-navigation");

            if (headerTop && headerMenus && !headerMenus.contains(headerTop)) {
                headerMenus.appendChild(headerTop);
            }
        };

        mobileHandler();

        mediaQuery.addEventListener("change", mobileHandler); // auto re-check breakpoint

    }

    

}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
    new TongkolspaceApp();
});

// Export for global access if needed
window.TongkolspaceApp = TongkolspaceApp;
